<template>
  <v-card flat>
    <v-card-title style="display: flex; justify-content: space-between">
      <v-row class="pt-5">
        <v-col cols="2"> {{ boardName }} </v-col>
        <v-col cols="5">
          <div class="ml-8">
          <span ref="searchContainer" v-if="searchClicked">
            <text-field-component-vue
              @keyup="getSearch"
              v-model="search"
              @input="getSearch()"
              placeholder="Search by created date"
              flat
              append-inner-icon="mdi-magnify"
            ></text-field-component-vue>
          </span>
          <v-icon v-else @click.stop="toggleSearch">mdi-magnify</v-icon>
        </div>
        </v-col>
        <v-col cols="2">
          <span style="display: flex; float: right" class="cursor-pointer">
            <v-menu
              v-model="menu"
              transition="scale-transition"
              location="bottom"
              :close-on-content-click="false"
            >
              <template v-slot:activator="{ props }">
                <v-icon v-bind="props">mdi-filter-outline</v-icon>
              </template>
              <v-list width="350px">
                <DashBoardFilter
                  :existFilterData="existFilterData"
                  :type="'openIssue'"
                  :type2="'live'"
                  @applyChange="applyChange"
                />
              </v-list>
            </v-menu>
          </span>
        </v-col>
        <v-col cols="3">
          <div style="display: flex; gap: 15px;">
            <div style="display: flex;">
          <v-switch
                v-model="switchBtn"
                false-value="OFF"
                true-value="ON"
                color="primary"
                hide-details
                @click="getSwitchData"
                style="margin-top: -10px"
              ></v-switch>
              <label for="switchBtn" style="font-size: small;margin-top: 4px;">Past Due Task</label>
            </div>
          <v-menu class="ml-8">
            <template v-slot:activator="{ props }">
              <i
                class="mt-2 pi pi-file-export"
                style="cursor: pointer;"
                v-bind="props"
              />
            </template>
            <v-list>
              <v-list-item
                v-for="(item, index) in downloadMenu"
                :key="index"
                :value="index"
              >
                <v-list-item-title @click="exportFile(item)">{{
                  item
                }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        
        </div>
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-actions v-if="chipName && chipName.length>0">
        <v-row>
          <v-col v-for="(workspace, workspaceIndex) in chipName"
        :key="workspaceIndex" cols="auto" class="cursor-pointer">
          <span class="workspace"  @click=changeIndex(workspaceIndex)>
            {{workspace.workSpaceName}}
          </span>
        </v-col>
        </v-row>
        </v-card-actions>
  </v-card>
  <v-divider></v-divider>
</template>

<script>
// import filterData from "./filterData.vue";
// import ProductionDashboardService from "@/api/service/ProductionDashboard/ProductionDashboard";
// import ExportService from "@/ExportService";
// import commonService from "@/common.service";
import TextFieldComponentVue from "../../../components/TextFieldComponent.vue";
import IssueService from "@/api/service/Issue/IssueService";
import DashBoardFilter from "@/modules/dashboard/Widgets/DashboardFilter.vue";
// import SkeletonForList from "../SkeletonForList.vue";

export default {
  props: ["boardName","existFilterData","workSpaceName"],
  components: {
    // filterData,
    TextFieldComponentVue,
    DashBoardFilter,
    // SkeletonForList
  },

  data() {
    return {
      menu: false,
      loading: true,
      downloadMenu: ["Excel", "Pdf", "Json"],
      ProductionData: [],
      search: null,
      searchClicked: false,
      tableData: [],
      finalExportData: [],
      backupTableData: [],
      isDrawer: false,
      switchBtn: "OFF",
      workTimingId: null,
      chipName:null
    };
  },

  async created() {
    // await this.getProductionData();
    this.finalExportData = this.tableData;
    this.chipName=[...this.workSpaceName]
  },
  computed: {

    isDrawerOpen() {
      return this.$store.getters.getIssueViewDrawer;
    },
    isIssueChanged() {
      return this.$store.getters.getDefaultIssueInView;
    },
  },
  watch: {
    isIssueChanged() {
      this.showIssueView = true;
    },
  },
  methods: {
    changeIndex(index){
      this.$emit('scroll' ,index)
    },
    applyChange($event) {
      localStorage.setItem('filterData',JSON.stringify($event))
      this.$emit("applyChange", $event);
      this.menu = false;
    },
    gettimingId(id) {
      this.workTimingId = id;
      console.log(
        this.workTimingId,
        "this.workTimingIdthis.workTimingIdthis.workTimingId"
      );
    },
    async getFilterData(data) {
      this.filterData = data;
      this.filterDialog = false;
      this.getissuetype(this.filterData);
      this.menu = false;
    },
    async getissuetype($obj) {
      let obj = {};
      if ($obj) {
        obj = $obj;
      }
      obj.next_action = this.userId;
      var res = await IssueService.getAssignToMeData(obj);
      this.issueType = res && res.length ? res : [];
    },
    getSwitchData() {
      this.$emit("show-zero-issue", this.switchBtn);
    },
    toggleSearch() {
      this.searchClicked = !this.searchClicked;
      if (this.searchClicked) {
        document.addEventListener("click", this.handleOutsideClick);
      } else {
        document.removeEventListener("click", this.handleOutsideClick);
      }
    },
    handleOutsideClick(event) {
      const textField = this.$refs.searchContainer;
      if (textField && !textField.contains(event.target)) {
        this.searchClicked = false;
        document.removeEventListener("click", this.handleOutsideClick);
      }
    },
    getSearch() {
      this.$emit("search-data", this.search);
    },

    addData(data) {
      this.finalExportData = data;
    },

    async exportFile(type) {
      this.$emit("export-data", type);
    },
  },
};
</script>

<style>
.workspace {
  background-color: #fdf4f4;
  border: 1.5px solid #ffa1a1;
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  text-align: left;
}
</style>
